const mode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'development' : 'production'
export const configuration = window.GLOBAL_CONFIGURATION[mode]
export const API = mode === 'production' ? configuration.API_HOST[window.location.hostname] : configuration.API_HOST;
export const PortalToken = window.GLOBAL_CONFIGURATION.portalToken
export const MUI_LICENSE_KEY = 'ad2c5b4746060f7cbc69eb86fcad12a3Tz0xMjk5MjgsRT0xODEyMzI2Mzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'

export const Languages = {
	EL: 'el',
	EN: 'en',
}

export const TimeUnitsIds = {
	Days: 1,
	Min: 2,
	Hours: 3
}

export const DiscountTypes = {
	Percentage: 1,
	NetValue: 0
};

export const TimeUnits = [
	{id: 1, Description: 'Days', isDefault: 1},
	{id: 2, Description: 'Min', isDefault: 0},
	{id: 3, Description: 'Hours', isDefault: 0},
]

export const IssueStatus = {
	AnamoniApodoxisKostous: 1,
	EktimisiKostous: 2,
	Anoixto: 3,
	OloklirothikeKaiTimologithike: 4, //oxi sto dashboard
	Epilithike: 5, //oxi sto dashboard // ενημερώθηκε το actual end date
	Anatethike: 6,
	OloklirothikeMeEggrafa: 7, //oxi sto dashboard
	Akurothike: 8, //oxi sto dashboard // ενημερώθηκε το actual end date
	AnamoniAntallaktikon: 9
}

export const IssueClosedStatusGroup = [IssueStatus.OloklirothikeKaiTimologithike, IssueStatus.Epilithike, IssueStatus.OloklirothikeMeEggrafa, IssueStatus.Akurothike]

export const checkListOptions = [
	// {value: '1', label: 'Completed satisfactorily'},
	// {value: '2', label: 'Completed with issues'},
	// {value: '3', label: 'Was not carried out'},
	// {value: '1', label: 'It happened'},
	// {value: '2', label: 'It didn`t happen'},
	// {value: '3', label: 'It happened badly'},
	{value: '1', label: 'Yes'},
	{value: '2', label: 'No'},
]

export const monthlyCheckListOptions = [
	{value: '1', label: 'Yes'},
	{value: '2', label: 'No'},
	{value: '3', label: 'Does not exist'},
]
export const trimesterCheckListOptions = [
	{value: '1', label: 'Yes'},
	{value: '2', label: 'No'},
	{value: '3', label: 'Postponement by Management'},
	// {value: '1', label: 'Completed satisfactorily'},
	// {value: '2', label: 'Completed with issues'},
	// {value: '3', label: 'Not required this month'},
	// {value: '4', label: 'Was not carried out'},
]

export const PriorityPlanned = '71';